import React, {useContext, useState} from "react"
import { injectIntl } from "react-intl"
import { makeStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme => ({
    root: {
        top: 0,
        fontSize: "22px",
        fontFamily:"Proxima Nova,Roboto,Helvetica,Arial,sans-serif",
        textAlign: "center",
        marginTop: "0px",
        height:"150px",
        paddingTop:"80px",
    },
    unsubscribe:{
        display: "block",
        marginBottom:"15px",
        marginTop:"0px"
    },
    link:{
        textDecoration:"none",
    }
}))

export default injectIntl(props => {
    const { intl } = props
    const id = props.userID
    async function updateCustomerToUnsubscribe() {
        let xhr = new XMLHttpRequest()
        xhr.open("PUT", "https://ickr3dus78.execute-api.us-east-2.amazonaws.com/prod/customer", false)
        xhr.setRequestHeader("Content-Type", "application/json")
        xhr.onreadystatechange = async function() {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                const jsonData = JSON.parse(this.response)
            }
        }
        const data = {
            customerId: id,
            subscribe:false,
            case: 1,
        }
        xhr.send(JSON.stringify(data))

    }
    updateCustomerToUnsubscribe()

    const i18nmessages = intl.messages

    const classes = useStyles()
    return (
        <div className={classes.root}>
            <p className={classes.unsubscribe}>{i18nmessages.unsubscribed}</p>
            <p className={classes.unsubscribe}>{i18nmessages.resubscribe} <a href="https://www.puraearth.com/" className={classes.link}>{i18nmessages.puraearth}</a></p>
        </div>
    )
})
